import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      item: item.href ? `https://heiliaowang.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap py-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <span key={index} className="flex items-center gap-1.5">
              {index > 0 && (
                <span className="text-foreground-700">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </span>
              )}
              {item.href && !isLast ? (
                <Link to={item.href} className="hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-300 font-medium" : ""}>{item.label}</span>
              )}
            </span>
          );
        })}
      </nav>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </>
  );
}